import { useState } from "react";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const FieldLabel = ({ children }) => (
  <label className="block text-[10px] uppercase tracking-[0.18em] font-semibold text-[#0A4730]/70 mb-2">
    {children}
  </label>
);

export function SignupMethodStep({ onNext }) {
  const navigate = useNavigate();
  const [usePhone, setUsePhone] = useState(false);

  const handleEmailOrPhoneContinue = () => {
    // Pass the chosen method or let the parent component handle the flow based on state
    onNext({ usePhone });
  };

  return (
    <div className="flex flex-col h-full w-full max-w-xl mx-auto bg-[#FDFDFD] p-5 md:p-8 text-left">
      {/* Back Button */}
      <button
        onClick={() => navigate("/")}
        className="mb-6 w-10 h-10 rounded-full border border-slate-200 bg-white flex items-center justify-center active:scale-95 transition text-[#0A4730]/60 hover:border-[#0A4730]/30 shadow-sm"
      >
        <ChevronLeft size={20} />
      </button>

      {/* Header */}
      <div className="mb-6 text-center">
        <h1 className="text-2xl text-[#0A4730] font-serif font-semibold tracking-tight mb-2">
          Sign Up
        </h1>
        <p className="text-slate-500 text-sm leading-relaxed max-w-sm mx-auto">
          Please choose a signup method to continue setting up your account
        </p>
      </div>

      <div className="space-y-6 flex-grow">
        {/* Main Action Card */}
        <div className="bg-white rounded-3xl p-6 border border-slate-100 shadow-[0_4px_20px_-5px_rgba(0,0,0,0.05)] space-y-4">
          {/* Modern Toggle Tabs */}
          <div>
            <FieldLabel>Register with</FieldLabel>
            <div className="grid grid-cols-2 p-1 bg-slate-100 rounded-2xl border border-slate-200/60 mb-4">
              <button
                type="button"
                onClick={() => setUsePhone(false)}
                className={`py-2 text-xs font-semibold rounded-xl transition-all duration-200 ${
                  !usePhone
                    ? "bg-white text-[#0A4730] shadow-sm"
                    : "text-slate-500 hover:text-[#0A4730]"
                }`}
              >
                Email
              </button>
              <button
                type="button"
                onClick={() => setUsePhone(true)}
                className={`py-2 text-xs font-semibold rounded-xl transition-all duration-200 ${
                  usePhone
                    ? "bg-white text-[#0A4730] shadow-sm"
                    : "text-slate-500 hover:text-[#0A4730]"
                }`}
              >
                Phone Number
              </button>
            </div>
          </div>

          <button
            onClick={handleEmailOrPhoneContinue}
            className="w-full h-14 rounded-2xl bg-[#0A4730] text-white font-bold tracking-wide hover:bg-[#0A4730]/90 transition-all shadow-lg active:scale-[0.98]"
          >
            {usePhone ? "Continue with Phone Number" : "Continue with Email"}
          </button>
        </div>
      </div>

      {/* Footer Link */}
      <div className="mt-8 text-center text-sm">
        <span className="text-slate-500">Have an account? </span>
        <button
          className="font-bold text-[#0A4730] hover:underline"
          onClick={() => navigate("/login")}
        >
          Login
        </button>
      </div>
    </div>
  );
}
